import { MdFamilyRestroom, MdWork, MdCheck } from 'react-icons/md';
import { t } from '../../utils/i18n';

const PARENT_ITEMS = ['item1', 'item2', 'item3', 'item4'];
const SITTER_ITEMS = ['item1', 'item2', 'item3', 'item4'];

export default function BenefitsSection() {
  return (
    <section className="landing-section landing-section--benefits">
      <div className="landing-container">
        <header className="landing-section-header">
          <h2 className="landing-section-title">
            {t('landing.benefits.title')}
          </h2>
          <p className="landing-section-subtitle mx-auto">
            {t('landing.benefits.subtitle')}
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
          <BenefitCard
            title={t('landing.benefits.parents.title')}
            intro={t('landing.benefits.parents.intro')}
            stat={t('landing.benefits.parents.stat')}
            icon={MdFamilyRestroom}
            items={PARENT_ITEMS}
            prefix="landing.benefits.parents"
          />
          <BenefitCard
            title={t('landing.benefits.sitters.title')}
            intro={t('landing.benefits.sitters.intro')}
            stat={t('landing.benefits.sitters.stat')}
            icon={MdWork}
            items={SITTER_ITEMS}
            prefix="landing.benefits.sitters"
          />
        </div>
      </div>
    </section>
  );
}

function BenefitCard({ title, intro, stat, icon: Icon, items, prefix }) {
  return (
    <article className="landing-benefit-card group h-full flex flex-col">
      <div className="landing-benefit-accent" aria-hidden="true" />

      <div className="landing-benefit-inner flex flex-col flex-1">
        <div className="flex items-start justify-between gap-4 mb-4">
          <div className="flex items-center gap-3 min-w-0">
            <span className="landing-benefit-icon w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0">
              <Icon className="text-xl text-primary-600 dark:text-primary-400" aria-hidden="true" />
            </span>
            <h3 className="text-lg font-semibold text-[var(--color-text)] leading-tight">{title}</h3>
          </div>
          <span className="landing-benefit-stat hidden sm:inline-flex flex-shrink-0">
            {stat}
          </span>
        </div>

        <p className="text-[15px] text-[var(--color-text-muted)] leading-relaxed mb-5">
          {intro}
        </p>

        <ul className="space-y-3 flex-1">
          {items.map((key) => (
            <li key={key} className="landing-benefit-row flex items-start gap-3">
              <span className="landing-benefit-check mt-0.5 flex-shrink-0" aria-hidden="true">
                <MdCheck className="text-sm" />
              </span>
              <span className="text-[15px] text-[var(--color-text)] leading-relaxed">
                {t(`${prefix}.${key}`)}
              </span>
            </li>
          ))}
        </ul>

        <span className="landing-benefit-stat sm:hidden mt-5 self-start">
          {stat}
        </span>
      </div>
    </article>
  );
}
